import { DocumentMyDeskResponse } from "apis/data-contracts";

export const DOCUMENT_TITLE = {
  ANALYSIS: { 수주정보관리: "수주정보관리" },
};

export const DECISION_MANAGER_COMMENT_FIELD_NAME = "documentApprove.comment";
export const DOCUMENT_TITLE_FIELD_NAME = "title";
export const ATTACHMENT_FILES = "attachmentFiles";
export const DECISION_MANAGER_FIELD_NAME = "decisionManager";
export const REFERENCE_MEMBER_FIELD_NAME = "referenceMember";

export const SUPERADMIN_UUID = "6b10ec66-e378-11ef-a99b-02b012ed9399";

export const CONTRACT_INFO_STEP1_FIELD = {
  PJ: {
    label: "PJ명",
    key: "projectName",
    type: "text",
    required: true,
    placeholder: "PJ명을 입력해 주세요.",
    minLength: 2,
    maxLength: 100,
  },
  INFORMATION_PROVIDER: {
    label: "정보제공자",
    key: "informationProvider",
    type: "text",
    required: true,
    placeholder: "정보 제공자를 입력해 주세요.",
    minLength: 2,
    maxLength: 20,
  },
  RECEIPT_DATE: {
    label: "접수일",
    key: "receiptDate",
    type: "date",
    dateFormat: "YYYY.MM.DD",
    required: true,
    placeholder: "접수일을 지정해 주세요.",
  },
  BUSINESS_METHOD: {
    label: "사업방식",
    key: "businessMethod",
    type: "text",
    required: true,
    placeholder: "사업방식을 입력해 주세요.",
    minLength: 2,
    maxLength: 200,
  },
  IMPLEMENTER_AND_RELATED_COMPANY: {
    label: "시행자 및 관계사",
    key: "implementerAndRelatedCompany",
    type: "text",
    required: false,
    placeholder: "시행자 또는 관계사를 입력해 주세요.",
    minLength: 2,
    maxLength: 200,
  },
  LAND_AREA: {
    label: "토지면적",
    key: "landArea",
    type: "group",
    fields: {
      LAND_AREA_IN_SQUARE_METERS: {
        label: "m²",
        key: "landArea.landAreaInSquareMeters",
        type: "number",
        required: true,
        minLength: 2,
        maxLength: 200,
      },
      LAND_AREA_IN_PYEONG: {
        label: "평",
        key: "landArea.landAreaInPyeong",
        type: "number",
        required: true,
        minLength: 2,
        maxLength: 200,
      },
    },
  },
  URBAN_MANAGEMENT_PLAN: {
    label: "도시관리계획",
    key: "urbanManagementPlan",
    type: "text",
    required: false,
    placeholder: "도시관리계획을 입력해 주세요.",
    minLength: 2,
    maxLength: 200,
  },
  BUSINESS_SCALE: {
    label: "사업규모",
    key: "businessScale",
    type: "text",
    required: false,
    placeholder: "사업규모를 입력해 주세요.",
    minLength: 2,
    maxLength: 200,
  },
  ADDITIONAL_NOTES: {
    label: "기타사항",
    key: "additionalNotes",
    type: "text",
    required: false,
    placeholder: "기타사항을 입력해 주세요.",
    minLength: 2,
    maxLength: 130,
  },
} as const;

export const CONTRACT_INFO_STEP2_FIELD = {
  PROFITABILITY_UNITS: {
    key: "profitabilityUnits",
    type: "group",
  },
  BASIC_REVIEW: {
    label: "기본검토",
    key: "basicReview",
    type: "group",
    fields: {
      LOCATION: {
        label: "입지",
        key: "location",
        type: "text",
        required: true,
        placeholder: "입지를 입력해 주세요",
        minLength: 2,
        maxLength: 300,
      },
      BUSINESS_RIGHT_ACQUISITION: {
        label: "사업권원확보",
        key: "businessRightAcquisition",
        type: "text",
        required: false,
        placeholder: "사업권원확보 여부를 입력해 주세요",
        minLength: 2,
        maxLength: 300,
      },
      PERMISSION: {
        label: "인허가",
        key: "permission",
        type: "text",
        required: false,
        placeholder: "인허가 여부를 입력해 주세요",
        minLength: 2,
        maxLength: 300,
      },
      MARKET_STATUS: {
        label: "시장현황",
        key: "marketStatus",
        type: "text",
        required: false,
        placeholder: "시장현황을 입력해 주세요",
        minLength: 2,
        maxLength: 300,
      },
      APPROPRIATE_SALE_PRICE: {
        label: "적정분양가",
        key: "appropriateSalePrice",
        type: "text",
        required: false,
        placeholder: "적정분양가를 입력해 주세요",
        minLength: 2,
        maxLength: 300,
      },
    },
  },

  PROFITABILITY: {
    label: "사업성",
    key: "profitability",
    type: "table",
    columns: [
      {
        label: "구분",
        key: "category",
        type: "text",
        required: true,
        minLength: 2,
        maxLength: 100,
      },
      {
        label: "금액",
        key: "amount",
        type: "number",
        required: true,
        minLength: 2,
        maxLength: 100,
        min: 0,
      },
      {
        label: "비고",
        key: "note",
        type: "text",
        required: false,
        minLength: 2,
        maxLength: 100,
      },
    ],
    rows: [
      { category: "매출액", amount: null, note: "" },
      { category: "토지비", amount: null, note: "" },
      { category: "공사비", amount: null, note: "" },
      { category: "기타원가", amount: null, note: "" },
      { category: "합계", amount: null, note: "" },
      { category: "이자후불", amount: null, note: "" },
      { category: "무이자", amount: null, note: "" },
    ],
  },
  REVIEW_RESULT: {
    label: "검토결과",
    key: "reviewResult",
    type: "text",
    required: false,
    placeholder: "검토결과를 입력해 주세요.",
    minLength: 2,
  },
  PROCESSING_RESULT: {
    label: "처리결과",
    key: "processingResult",
    type: "radioButtonGroup",
    options: ["사업추진", "보류", "사업불가"],
    required: true,
  },
} as const;

export const LEAVE_APPLICATION_FIELD = {
  NAME: { label: "성명", key: "name" },
  COMPANY_POSITION: { label: "직급", key: "companyPosition" },
  LEAVE_TYPE: {
    key: "leaveType",
    label: "종류",
    options: ["종일", "오전", "오후"],
  },
  LEAVE_REASON: {
    key: "leaveReason",
    label: "사유",
    minLength: 2,
    maxLength: 1000,
  },
  START_DATE: { key: "startDate", dateFormat: "YYYY.MM.DD" },
  END_DATE: { key: "endDate", dateFormat: "YYYY.MM.DD" },
  TOTAL_DAYS: { key: "totalDays" },
  REMAINING_PAID_LEAVE: { key: "remainingPaidLeave" },
  REMAINING_ANNUAL_LEAVE: { key: "remainingAnnualLeave" },
  NOTES: { key: "notes", label: "비고", minLength: 2, maxLength: 1000 },
} as const;

export const RECEIVE_OFFICIAL_LETTER_FIELD = {
  DOCUMENT_RECEIPT_NUMBER: {
    label: "공문수신번호",
    key: "documentReceiptNumber",
  },
  SENDER: { label: "발신자", key: "sender", minLength: 2, maxLength: 50 },
  REGISTRATION_DATE: {
    label: "수신일",
    key: "registrationDate",
    dateFormat: "YYYY.MM.DD",
  },
  TITLE: {
    label: "제목",
    key: DOCUMENT_TITLE_FIELD_NAME,
    minLength: 2,
    maxLength: 200,
  },
} as const;

export const SEND_OFFICIAL_LETTER_FIELD = {
  DOCUMENT_SEND_NUMBER: {
    label: "공문발신번호",
    key: "documentSendNumber",
  },
  RECEIVER: {
    label: "수신자",
    key: "receiver",
    minLength: 2,
    maxLength: 50,
  },
  REGISTRATION_DATE: {
    label: "발신일",
    key: "registrationDate",
    dateFormat: "YYYY.MM.DD",
  },
  TITLE: {
    label: "제목",
    key: DOCUMENT_TITLE_FIELD_NAME,
    minLength: 2,
    maxLength: 200,
  },
} as const;

export const EXPENSE_REPORT_FIELD = {
  EXPENSE_NOTE: {
    label: "지출내용",
    key: "expenseNote",
    type: "text",
    required: true,
    minLength: 2,
    maxLength: 200,
  },
  EXECUTION_PERIOD: {
    label: "집행기한",
    key: "executionPeriod",
    dateFormat: "YYYY.MM.DD",
    type: "date",
    required: true,
  },
  EXPENSE_DETAILS: {
    label: "세부내역",
    key: "expenseDetails",
    type: "array",
    required: true,
    itemFields: [
      {
        label: "적요",
        key: "description",
        type: "text",
        required: true,
        minLength: 2,
        maxLength: 100,
      },
      {
        label: "금액",
        key: "amount",
        type: "number",
        required: false,
        minLength: 2,
        maxLength: 100,
        min: {
          value: 1,
          message: "1 이상의 숫자만 입력 가능",
        },
      },
      {
        label: "지급처",
        key: "paymentPlace",
        type: "text",
        required: true,
        minLength: 2,
        maxLength: 100,
      },
      {
        label: "지급계좌",
        key: "paymentAccount",
        type: "text",
        required: true,
        minLength: 2,
        maxLength: 100,
      },
    ],
  },
  TOTAL_AMOUNT: {
    label: "합계",
    key: "totalAmount",
    type: "calculated",
    calculationFormula: "SUM(expenseDetails.amount)",
    readOnly: true,
    required: true,
  },
} as const;

export const MINUATES_OF_MEETING_FIELD = {
  MEETING_DATE: {
    label: "날짜",
    key: "meetingDate",
    dateFormat: "YYYY.MM.DD HH:mm",
    placeholder: "날짜를 선택해 주세요.",
  },
  LOCATION: {
    label: "장소",
    key: "location",
    placeholder: "회의 장소를 입력해 주세요.",
    minLength: 2,
    maxLength: 200,
  },
  PURPOSE: {
    label: "목적",
    key: "purpose",
    placeholder: "회의 목적을 작성해 주세요.",
    minLength: 2,
    maxLength: 1000,
  },
  ATTENDEES: {
    label: "참석자",
    key: "attendees",
    itemFields: [
      { label: "소속", key: "affiliation", minLength: 2, maxLength: 20 },
      { label: "직급", key: "position", minLength: 2, maxLength: 20 },
      { label: "이름", key: "name", minLength: 2, maxLength: 20 },
    ],
  },
  CONTENT: {
    label: "내용",
    key: "content",
    placeholder: "내용을 입력해 주세요.",
    minLength: 2,
    maxLength: 5000,
  },
} as const;

export const KSS_FIELD = {
  TITLE: {
    label: "제목",
    key: DOCUMENT_TITLE_FIELD_NAME,
    minLength: 2,
    maxLength: 200,
  },
  CONTENT: { label: "내용", key: "content", minLength: 2, maxLength: 5000 },
} as const;

export const REPORT_FIELD = {
  TITLE: {
    label: "제목",
    key: DOCUMENT_TITLE_FIELD_NAME,
    minLength: 2,
    maxLength: 200,
  },
  CONTENT: { label: "내용", key: "content", minLength: 2, maxLength: 5000 },
} as const;

export const LETTER_OF_APPROVAL_FIELD = {
  DOCUMENT_NUMBER: { label: "문서번호", key: "documentNumber" },
  TITLE: {
    label: "제목",
    key: DOCUMENT_TITLE_FIELD_NAME,
    minLength: 2,
    maxLength: 200,
  },
  CONTENT: { label: "내용", key: "content", minLength: 2, maxLength: 5000 },
} as const;

export const CORP_CARD_USAGE_PROOF_FIELD = {
  USAGE_DATE: {
    label: "사용일자",
    key: "usageDate",
    dateFormat: "YYYY.MM.DD",
    type: "date",
    required: true,
  },
  USAGE_DETAILS: {
    label: "결제금액",
    key: "usageDetails",
    type: "array",
    required: true,
    itemFields: [
      {
        label: "금액",
        key: "amount",
        type: "number",
        required: true,
        minLength: 2,
        maxLength: 200,
        min: {
          value: 1,
          message: "결제금액 기입 필수",
        },
      },
    ],
  },
  USAGE_TYPE: {
    key: "usageType",
    label: "증빙 사유 유형",
    options: [
      "20만 원 초과",
      "접대비 사용",
      "주말/공휴일 사용",
      "온라인/모바일 결제",
    ],
    required: true,
  },
  USAGE_REASON: {
    key: "usageReason",
    label: "사용목적",
    minLength: 2,
    maxLength: 2000,
    required: true,
  },
  USAGE_CLIENTS: {
    label: "(해당 시)<br/> 접대 대상자",
    key: "usageClients",
    type: "array",
    required: false,
    itemFields: [
      {
        label: "접대 대상자 소속 및 성명",
        key: "clientsDescription",
        type: "text",
        required: false,
        minLength: 1,
        maxLength: 1000,
        placeholder: "접대 대상자 소속 및 성명을 입력해 주세요.",
        message: "1~1000자 이내 입력 가능",
      },
      {
        label: "인원수",
        key: "number",
        type: "text",
        required: false,
        minLength: 1,
        maxLength: 200,
        placeholder: "인원수를 입력해 주세요.",
        message: "1~200자 이내 입력 가능",
      },
    ],
  },
} as const;

export const DOCUMENT_DETAIL_FIELD = {
  COMMENT: {
    label: "결재자 코멘트",
    key: "comment",
    placeholder: "코멘트를 입력해 주세요.",
  },
  REFERENCE_USERS: {
    label: "참조자",
    key: "referenceUsers",
  },
} as const;

export const EDITABLE_DOCUMENT_STATUS_LIST: DocumentMyDeskResponse["status"][] =
  ["TEMP", "REQ_SUPPLEMENT"];
export const EDITABLE_APPROVE_STATUS = ["REQ_SUPPLEMENT"];
export const APPROVABLE_APPROVE_STATUS = [
  "REVIEW_IN_PROGRESS",
  "APPROVE_IN_PROGRESS",
  "REQ_SUPPLEMENT",
];
